<template>
  <div :class="classDef">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'Container',
    props: {
      sm: {
        type: String,
        default: "12"
      },
      md: {
        type: String,
        default: "0"
      },
      lg: {
        type: String,
        default: "0"
      },
      cls: {
        type: String,
        default: ""
      }
    },
    created() {
      
    },
    computed: {
      classDef() {
        let cls = `col-sm-${this.sm}`;
        if (this.md !== "0") cls += ` col-md-${this.md}`;
        if (this.lg !== "0") cls += ` col-lg-${this.lg}`;
        if (this.cls.length > 0) cls += ' ' + this.cls;
        return cls;
      }
    }
  }
</script>


// WEBPACK FOOTER //
// container.vue?04c9f55f